const ColombiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111193)">
      <path
        d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20L20 21.7391L0 20Z"
        fill="#FFDA44"
      />
      <path
        d="M2.67676 29.9997C6.13496 35.9775 12.5978 39.9997 20.0005 39.9997C27.4032 39.9997 33.8661 35.9775 37.3243 29.9997L20.0005 28.6953L2.67676 29.9997Z"
        fill="#D80027"
      />
      <path
        d="M37.3237 30C39.0255 27.0583 40 23.643 40 20H0C0 23.643 0.974531 27.0583 2.67625 30H37.3237Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111193">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ColombiaSvg;
